var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99792 1.62891C7.66492 1.62932 6.357 1.99129 5.21345 2.67626C4.06991 3.36123 3.13357 4.34356 2.50417 5.5186C1.87476 6.69364 1.57587 8.0174 1.63931 9.34889C1.70275 10.6804 2.12615 11.9697 2.86443 13.0796L1.62866 16.3674L5.76678 15.6192C6.76323 16.1061 7.85673 16.3618 8.96577 16.3673C10.0748 16.3728 11.1708 16.1279 12.172 15.6509C13.1732 15.1738 14.0539 14.477 14.7483 13.6122C15.4427 12.7474 15.9329 11.7371 16.1825 10.6565C16.4321 9.57587 16.4345 8.45286 16.1897 7.37117C15.9448 6.28949 15.459 5.27701 14.7683 4.40923C14.0777 3.54145 13.2001 2.84074 12.201 2.35934C11.2019 1.87793 10.107 1.62825 8.99792 1.62891V1.62891Z",
    stroke: "#949A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29736 7.29825C7.29736 6.96191 7.3971 6.63311 7.58397 6.35345C7.77083 6.07379 8.03643 5.85582 8.34717 5.72711C8.65791 5.59839 8.99985 5.56472 9.32973 5.63033C9.65961 5.69595 9.96263 5.85792 10.2005 6.09575C10.4383 6.33358 10.6003 6.6366 10.6659 6.96648C10.7315 7.29637 10.6978 7.6383 10.5691 7.94904C10.4404 8.25979 10.2224 8.52538 9.94276 8.71225C9.6631 8.89911 9.33431 8.99885 8.99796 8.99885V10.1326",
    stroke: "#949A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 12.9692C8.84345 12.9692 8.71655 12.8423 8.71655 12.6858C8.71655 12.5292 8.84345 12.4023 8.99999 12.4023",
    stroke: "#949A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99977 12.9692C9.15631 12.9692 9.2832 12.8423 9.2832 12.6858C9.2832 12.5292 9.15631 12.4023 8.99977 12.4023",
    stroke: "#949A9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.da423e414ac6084f8f5a9f79cc4210dc.svg";
export { ForwardRef as ReactComponent };